/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSubwayIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-subway"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.6 19.75L1.6 8.8Q1.6 6.58 2.74 4.9Q3.88 3.23 6 2.4Q7.42 1.82 9 1.71Q10.57 1.6 12 1.6Q13.43 1.6 15 1.71Q16.57 1.82 18 2.4Q20.13 3.23 21.26 4.9Q22.4 6.58 22.4 8.8L22.4 19.75Q22.4 20.88 21.64 21.64Q20.88 22.4 19.75 22.4L4.25 22.4Q3.13 22.4 2.36 21.64Q1.6 20.88 1.6 19.75ZM7.4 12.95L7.4 8.95L16.6 8.95L16.6 12.95ZM15.65 16.6Q15.65 16.6 15.44 16.6Q15.22 16.6 14.91 16.29Q14.6 15.97 14.6 15.55Q14.6 15.13 14.91 14.81Q15.22 14.5 15.65 14.5Q16.07 14.5 16.39 14.81Q16.7 15.13 16.7 15.55Q16.7 15.97 16.39 16.29Q16.07 16.6 15.65 16.6ZM8.35 16.6Q8.35 16.6 8.14 16.6Q7.92 16.6 7.61 16.29Q7.3 15.97 7.3 15.55Q7.3 15.13 7.61 14.81Q7.92 14.5 8.35 14.5Q8.78 14.5 9.09 14.81Q9.4 15.13 9.4 15.55Q9.4 15.97 9.09 16.29Q8.78 16.6 8.35 16.6ZM10.65 18.65L13.3 18.65L14.63 19.93Q14.75 20.05 14.89 20.1Q15.03 20.15 15.18 20.15Q15.75 20.15 15.96 19.66Q16.18 19.18 15.8 18.8L15.6 18.6L15.6 18.6Q16.7 18.45 17.48 17.59Q18.25 16.73 18.25 15.55L18.25 8.95Q18.25 6.83 16.31 6.29Q14.38 5.75 12 5.75Q9.63 5.75 7.69 6.29Q5.75 6.83 5.75 8.95L5.75 15.55Q5.75 16.73 6.53 17.59Q7.3 18.45 8.4 18.6L8.4 18.6L8.2 18.8Q7.83 19.18 8.04 19.66Q8.25 20.15 8.78 20.15Q8.95 20.15 9.07 20.1Q9.2 20.05 9.32 19.93Z" fill={color} />
    </svg>
  );
}
